import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { SplashScreen } from '@capacitor/splash-screen';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { PlatformService } from './app/shared/services/platform.service';

if (environment.production) {
  enableProdMode();
}

// A native shell is an app, not a page: Safari zooms in on a focused field
// under 16px and never zooms back out. On the web the zoom stays available.
if (PlatformService.isNativePlatform()) {
  document.querySelector('meta[name="viewport"]')?.setAttribute(
    'content',
    'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover, interactive-widget=resizes-content'
  );

  // The boot splash in index.html is on screen by now, but its logo may still
  // be loading: wait for that file, then for the next painted frame, so the
  // native launch screen lifts off an identical picture.
  const logo: HTMLImageElement = new Image();
  logo.src = 'assets/img/brand/envision-letter.svg';
  logo.decode().catch(() => undefined).then(() => {
    requestAnimationFrame(() => requestAnimationFrame(() => {
      void SplashScreen.hide().catch((error: unknown) => console.warn('[splash] hide failed:', error));
    }));
  });
}

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(err => console.error(err));

